﻿export default class QuestionsModel {
	constructor() {
		this.ContractedCovid = null;
		this.CovidDiagnosedDate = null;
		this.PsyciatricInjury = null;
		this.PsyciatricInjuryDiagnosis = null;

		this.AdmittedToHospital = null;
		this.AdmmittedToIcu = null;
		this.IsHospitalised = null;
		this.HospitalizedDays = null;
		this.AdmittedICU = null;
		this.IcuDays = null;
		this.TreatementType = null;
		this.CovidSymptoms = null;
		this.OnGoingSymptoms = null;
		this.Diagnosis = null;
		this.DayToDayImpact = null;
		this.ImpactDetail = null;
		this.RequireOnGoingTreatment = null;
		this.ContinueSymptoms = null;
		this.LastExperienceSymptoms = null;
		this.SymptomsTreatment = null;
		this.Consent = null;
		this.NumberOfGP = null;
	}
}
